<div>
  <hub-modal-header headerText="{{ 'bikeshop.workshop.jobcard.customer.edit_customer_details' | translate }}"
                    [activeModal]="activeModal"></hub-modal-header>
</div>

<div class="modal-content-container">

  <div class="tab-container">
    <div class="waiver-tab-container">
      <div class="waiver-tab"
           [ngClass]="{'selected': showCustomerDetails}" (click)="showSteps('customerDetails')">
        <div>{{'bikeshop.bike_sale.customer_details' | translate }}</div>
      </div>
      <div class="waiver-tab"
           [ngClass]="{'selected': showAddressDetails}" (click)="showSteps('addressDetails')">
        <div>{{ 'bikeshop.rentals.booking.address' |  translate  }}</div>
      </div>
    </div>
  </div>

  <br />
  <div *ngIf="showCustomerDetails">

    <div class="row">
      <div class="col-lg-12">
        <div class="customer-message">{{'bikeshop.workshop.jobcard.customer.required_message' | translate}}</div>
      </div>
    </div>

    <div class="row margin-top-16">
      <div class="col-lg-6 input-control">
        <hub-input [(ngModel)]="customer.Name" label="{{'general.firstname' | translate}}"></hub-input>
      </div>
      <div class="col-lg-6 input-control">
        <hub-input [(ngModel)]="customer.Surname" label="{{'general.surname' | translate}}"></hub-input>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-12 input-control">
        <hub-input [(ngModel)]="customer.PhoneNumber" label="{{'onboarding.mobilenumber' | translate}}"></hub-input>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-12 input-control">
        <hub-input [(ngModel)]="customer.Email" label="{{'onboarding.email' | translate}}"></hub-input>
      </div>

    </div>
  </div>

  <div *ngIf="showAddressDetails">
    <app-edit-user-addresses [user]="customer" (canUpdate)="setUpdating($event)"></app-edit-user-addresses>
  </div>
</div>

<div class="modal-footer-container">
  <div class="button-container">
    <hub-button [disabled]="jobcard.id > 0 || jobcard.id < 0" [text]="'bikeshop.workshop.jobcard.customer.remove_customer' | translate"
                [style]="'borderless-secondary'" [size]="'xl'" (buttonClick)="removeCustomer()"></hub-button>
    <hub-button [text]="'general.update_details' | translate" [style]="'secondary'" [size]="'xl'"
                [loading]="updating" [disabled]="!isValidCustomer() || updating || busy"
                (buttonClick)="updateCustomer()"></hub-button>
  </div>
  <div class="short-cut-container">
    <div>
      {{'bikeshop.workshop.jobcard.quote.to_navigate' | translate}}
    </div>
    <div>
      <span>
        <daz-icon [name]="'enter'" [size]="'18px'"
                  [color]="'#6B728C'"></daz-icon>
      </span>{{
'bikeshop.workshop.jobcard.quote.to_save_and_close' |
            translate
      }}
    </div>
  </div>
</div>
<p-toast position="top-center" styleClass="hubtiger-toast"></p-toast>
